module.exports = __webpack_public_path__ + "img/4-3.49223754.svg";